import React, { Component } from 'react';
import Navbar from '../components/Navbar';
import ComingSoon from '../components/ComingSoon';

class Reports extends Component {
  render() {
    return (
      <div className="min-h-screen bg-slate-50">
        <Navbar />

        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* Header */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-slate-900">Reports</h1>
            <p className="text-slate-600 mt-1">Analyze your job data with powerful reporting tools</p>
          </div>

          {/* Coming Soon Content */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200">
            <ComingSoon 
              title="Reports Coming Soon"
              description="We're building comprehensive reporting and analytics tools to help you gain insights into your jobs, team performance, and project timelines."
              icon="reports"
            />
          </div>
        </main>
      </div>
    );
  }
}

export default Reports;